<template>
  <span></span>
</template>

<script>
export default {
  name: "query-string-to-state",
  props: {
    variables: Array
  },
  mounted() {
    this.variables.forEach((variable) => {
      if (variable.state !== "formData") {
        this.$store.state[variable.state] = this.$route.query[variable.query];
      } else {
        const o = new Object();
        o[variable.query] = this.$route.query[variable.query];
        this.$store.state[variable.state] = o;
      }
    });
  }
};
</script>
